import { useState } from 'react';

// import useScreenSize from '@/hooks/useScreenSize';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';
import Text from '@/shared-components/text/components/Text';

import SearchFiltersContent from './search-filters-content';

import './index.css';

function SearchFiltersMobile({ query, setQuery, close }) {
  const [localQuery, setLocalQuery] = useState(query);

  function applyFilters() {
    setQuery(localQuery);
    close();
  }

  return (
    <>
      <div className="search-filters-mobile__container">
        <div className="search-filters-mobile__header">
          <Text className="search-filters-mobile__header-text" >
            Filter by
          </Text>

          <XIcon className="search-filters-mobile__header-close" onClick={close}/>
        </div>

        <div className="search-filter-mobile__content-outter">
          <div className="search-filters-mobile__content">
            <SearchFiltersContent 
              query={localQuery} 
              setQuery={setLocalQuery} 
              isMobile
            />
          </div>
        </div>

        <div className="search-filters-mobile__apply-container">
          <ContinueButton className="search-filters-mobile__apply-button" onClick={applyFilters}>
             Apply filters
          </ContinueButton>
        </div>
      </div>
    </>
  );
}

export default function SearchFilters({ query, setQuery, open, close }) {
  return (
    <>
      <PopupToBottomSheet 
        className="search-filters-bottom-sheet element-non-selectable" 
        open={open} 
        close={close}
        popupOptions={{ darkerBlur: true }}      
      >
        <SearchFiltersMobile 
          query={query} 
          setQuery={setQuery} 
          close={close}
        />
      </PopupToBottomSheet>
    </>
  );
  // }
}
